import { useParams } from 'react-router-dom';
import { OrdersList } from './OrdersList';
import { FC } from 'react';

export const OrdersListWithPatient: FC = () => {
  const { patientId } = useParams<{ patientId: string }>();

  return <OrdersList patientId={patientId} hideCreateButton />;

};

